export const errorMessage = "Sorry, something went wrong. Please try again later"